console.log('main-only-drmvsn');

const mainPrdSwiper = new Swiper(".main-prd-swiper", {
    direction: 'horizontal',
    slidesPerView: 'auto',
    spaceBetween: 10,
    slidesOffsetAfter: 32,
    pagination: {
        el: ".main-prd-swiper .swiper-pagination",
        type: "fraction",
    },
    navigation: {
        nextEl: ".main-prd-swiper .swiper-button-next",
        prevEl: ".main-prd-swiper .swiper-button-prev",
      },
    scrollbar: {
        el: ".main-prd-swiper .swiper-scrollbar",
    },
    breakpoints: {
      990: {
        slidesPerView: 'auto',
        spaceBetween: 20,
        slidesOffsetAfter: 80,
      },
    }
  });


